import Header from './Header';

const Services = () => <Header label="Services" />;

export default Services;
